var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout"},[(_vm.route.meta.isShowHeader)?_c('layout-header'):_vm._e(),_vm._v(" "),_c('el-main',{style:({marginLeft:_vm.layoutMarginLeft+'px',marginTop:_vm.LayoutHeaderHeight+'px',padding:0})},[_c('div',{staticClass:"nav"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},_vm._l((_vm.breadcrumbList),function(item,index){return _c('el-breadcrumb-item',{attrs:{"to":{ path: item.path }}},[_vm._v("\n              "+_vm._s(item.name)+"\n            ")])}),1)],1),_vm._v(" "),_c('transition',{attrs:{"name":"fade-transform"}},[_c('keep-alive',[(_vm.route.meta.keepAlive)?_c('router-view',{style:({
							zIndex: 0,
							// minWidth: 1920 + 'px',
							minHeight: _vm.viewHeight + 'px',
							backgroundColor: '#F5F6F7',
						})}):_vm._e()],1)],1),_vm._v(" "),_c('transition',{attrs:{"name":"fade-transform"}},[(!_vm.route.meta.keepAlive)?_c('router-view',{style:({
						zIndex: 0,
						// width: 1920 + 'px',
						minHeight: _vm.viewHeight + 'px',
						backgroundColor: '#F5F6F7',
					})}):_vm._e()],1)],1),_vm._v(" "),_c('layout-footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4048520a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/framework/layout/layout.vue
// module id = YIPc
// module chunks = 30